import React from 'react';
import { HStack, VStack, Text, Badge, Tooltip, useBreakpointValue } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import { Event } from '../../types/types';
import RuleSetBadge from '../common/RuleSetBadge';

interface EventTeamInfoProps {
  event: Event;
}

export const EventTeamInfo: React.FC<EventTeamInfoProps> = ({ event }) => {
  // Responsive values
  const fontSize = useBreakpointValue({ base: 'xs', md: 'sm' });
  const secondaryFontSize = useBreakpointValue({ base: '2xs', md: 'xs' });
  return (
    <VStack spacing={0} align="start" width="100%">
      <HStack spacing={1}>
        {event.isCorrupted && (
          <Tooltip label="Event data is corrupted or incomplete" placement="top">
            <WarningIcon color="orange.500" boxSize={3} />
          </Tooltip>
        )}
        <Text fontSize={fontSize} noOfLines={1}>{event.firstCompetitor.name}</Text>
        <Text fontSize={secondaryFontSize} color="gray.500">vs</Text>
        <Text fontSize={fontSize} noOfLines={1}>{event.secondCompetitor.name}</Text>
      </HStack>
      <HStack spacing={1}>
        <Text fontSize={secondaryFontSize} color="gray.500" noOfLines={1}>{event.competition.name}</Text>
        <Text fontSize={secondaryFontSize} color="gray.500" display={{ base: 'none', sm: 'inline' }}>•</Text>
        <RuleSetBadge size="sm" fontSize={secondaryFontSize} ruleSet={event.competition.ruleSet} />
        <Badge
          size="sm"
          fontSize={secondaryFontSize}
          colorScheme={event.competition.marginLevel ? 'teal' : 'gray'}
        >
          margin: {event.competition.marginLevel ?? 'default'}
        </Badge>
      </HStack>
    </VStack>
  );
};
